import { createAction } from "redux-actions";

export const LOGOUT = "LOGOUT";
export const logoutAction = createAction(LOGOUT);
